import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '../shared.global-service';

@Pipe({
    name: 'formatDaysDiff',
})
export class FormatDaysDiffPipe implements PipeTransform {
    transform(daysDiff: any): string {
        return formatDaysDiff(daysDiff);
    }
}

export function formatDaysDiff(daysDiff: number): string {
    return daysDiff <= 0 ? translate.instant('folderMedication.0days')
        : daysDiff === 1 ? translate.instant('folderMedication.1day')
            : daysDiff < 5 ? daysDiff + translate.instant('folderMedication.lte4days')
                : daysDiff + translate.instant('folderMedication.gt4days');
}
